import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import "./CreateUser.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Col, Spinner, ProgressBar } from "react-bootstrap";

export default function BulkUpload({ show, closeModal, refreshPage }) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [progress, setProgress] = useState(0); // For progress tracking (optional)

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setValidationError({}); // Clear any previous validation errors
    };

    // Handle file upload submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            toast.error("Please select a file to upload.");
            return;
        }

        setIsLoading(true);
        setProgress(0); // Reset progress (if using progress tracking)

        const formData = new FormData();
        formData.append("file", file);

        try {
            // Submit the file to the backend for processing
            const response = await axiosInstance.post(
                "/user/base_user/import",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    
                }
            );

            // Close modal and refresh the page if successful
            handleClose();
            refreshPage();
            toast.success("Users uploaded successfully!");
        } catch (error) {
            console.error("Error uploading file:", error);
            let errorMessage = "Failed to upload users.";
            if (error.response) {
                if (error.response.data.errors) {
                    setValidationError(error.response.data.errors);
                    errorMessage = Object.values(error.response.data.errors)
                        .flat()
                        .join(" ");
                } else if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
            setProgress(0); // Reset progress (if using progress tracking)
        }
    };

    const handleClose = () => {
        setFile(null);
        setValidationError({});
        setProgress(0); // Reset progress (if using progress tracking)
        closeModal();
    };

    return (
        <div className="CreateUser">
            <Modal show={show} onHide={handleClose}>
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Bulk User Upload</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="formFileUpload" className="mb-3">
                            <Form.Label>Upload Excel File</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx, .xls" // Removed .csv to match backend
                                onChange={handleFileChange}
                                required
                            />
                            {validationError.file && (
                                <small className="text-danger my-1">
                                    {validationError.file[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Col md={12} className="mb-2">
                            <p className="text-muted">
                                Please ensure your Excel file includes the columns: First Name, Last Name, Email, Phone, Password for base users,
                                and Base User First Name, Base User Last Name, Base User Email, Base User Phone, Base User Password for sub-accounts.
                            </p>
                        </Col>
                        {isLoading && (
                            <ProgressBar
                                animated
                                now={progress}
                                label={`${progress}%`}
                                className="mb-3"
                            />
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            style={{ backgroundColor: "#c4281b", color: "#fff" }}
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />{" "}
                                    Uploading...
                                </>
                            ) : (
                                "Upload"
                            )}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}